import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const problems = [
  {
    title: 'Manual, Excel-and-email workflows',
    description:
      'Reduction amounts are calculated by hand and tracked across spreadsheets and a shared negotiation inbox.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="1.8" />
        <path d="M3 9h18M3 15h18M9 3v18M15 3v18" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    ),
  },
  {
    title: 'Providers ignore the first email',
    description:
      'Medical providers routinely ignore initial outreach — follow-up ends up depending on who remembers to chase it.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.8" />
        <path d="M3 7l9 7 9-7" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: 'Funds sit undisbursed for 30+ days',
    description:
      'Without a system driving negotiations forward, settled cases stay open far longer than they need to.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8" />
        <path d="M12 7v5l3.5 2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
];

const Problem = () => {
  return (
    <section className="problem" id="product" aria-labelledby="problem-heading">
      <Container>
        <Row className="justify-content-center text-center">
          <Col xs={12} lg={8}>
            <p className="problem__eyebrow">The Problem</p>
            <h2 id="problem-heading" className="problem__title">
              Settled cases shouldn’t sit for weeks.
            </h2>
            <p className="problem__description mx-auto">
              Every day a lien negotiation stalls is a day your client’s settlement
              <br />
              — and your firm’s fee — waits.
            </p>
          </Col>
        </Row>

        <Row className="g-3 g-lg-4">
          {problems.map((item) => (
            <Col key={item.title} xs={12} md={6} lg={4}>
              <article className="problem__card h-100">
                <div className="problem__icon">{item.icon}</div>
                <h3 className="problem__card-title">{item.title}</h3>
                <p className="problem__card-text mb-0">{item.description}</p>
              </article>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Problem;
